// src/components/Layout.jsx
import { useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebaseConfig";
import "./Layout.css";

// ✅ pon tu logo aquí (ajusta la ruta)
import logo512 from "../assets/logo.png";

const linkStyle = (active) => ({
  padding: "0.55rem 0.75rem",
  borderRadius: "0.6rem",
  textDecoration: "none",
  color: active ? "#111827" : "white",
  backgroundColor: active ? "white" : "transparent",
  fontWeight: active ? 800 : 600,
  fontSize: "0.95rem",
  border: active ? "1px solid rgba(255,255,255,0.20)" : "1px solid rgba(255,255,255,0.14)",
});

const logoutButtonStyle = {
  marginTop: "1rem",
  padding: "0.6rem 0.75rem",
  borderRadius: "0.6rem",
  border: "none",
  width: "100%",
  textAlign: "left",
  cursor: "pointer",
  backgroundColor: "#DC2626",
  color: "white",
  fontWeight: 800,
};

export default function Layout() {
  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);
  const toggleMenu = () => setIsMenuOpen((v) => !v);

  // ✅ Ajusta activos a tus rutas reales:
  const isActive = (path) => pathname === path;

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login", { replace: true });
    } catch (e) {
      console.error("Error al cerrar sesión", e);
    }
  };

  return (
    <div className="app-layout">
      {/* Header solo móviles */}
      <header className="mobile-header">
        <div className="mobile-header-left">
          <img
            src={logo512}
            alt="MyShopCity"
            className="mobile-logo"
            onError={(e) => (e.currentTarget.style.display = "none")}
          />
          <span className="app-logo-text">MyShopCity Admin</span>
        </div>

        <button
          type="button"
          className="mobile-menu-button"
          onClick={toggleMenu}
          aria-label="Abrir menú"
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      {/* Overlay móvil */}
      {isMenuOpen && <div className="mobile-overlay" onClick={closeMenu} />}

      {/* Sidebar */}
      <aside className={`sidebar ${isMenuOpen ? "sidebar-open" : ""}`}>
        <div className="sidebar-brand">
          <img
            src={logo512}
            alt="Logo"
            className="sidebar-logo"
            onError={(e) => (e.currentTarget.style.display = "none")}
          />
          <h2 className="sidebar-title">MyShopCity</h2>
          <div className="sidebar-subtitle">Panel Administrador</div>
        </div>

        <nav className="sidebar-nav">
          <Link
            style={linkStyle(isActive("/admin"))}
            to="/admin"
            onClick={closeMenu}
          >
            Dashboard
          </Link>

          <Link
            style={linkStyle(isActive("/misVentas"))}
            to="/misVentas"
            onClick={closeMenu}
          >
            Mis Ventas
          </Link>


          <Link
            style={linkStyle(isActive("/misProductos"))}
            to="/misProductos"
            onClick={closeMenu}
          >
            Mis productos
          </Link>

           <Link
            style={linkStyle(isActive("/anuncioGeneral"))}
            to="/anuncioGeneral"
            onClick={closeMenu}
          >
            Crear Anuncio
          </Link>

          

          

          {/* ✅ Placeholder (si quieres) */}
          <Link
            style={linkStyle(isActive("/admin/productos/nuevo"))}
            to="/admin/productos/nuevo"
            onClick={closeMenu}
          >
            Crear producto
          </Link>

          <div className="sidebar-divider" />

          {/* Legales / soporte */}
          <Link
            style={linkStyle(isActive("/privacy-policy"))}
            to="/privacy-policy"
            onClick={closeMenu}
          >
            Política de privacidad
          </Link>

          <Link
            style={linkStyle(isActive("/terms-and-conditions"))}
            to="/terms-and-conditions"
            onClick={closeMenu}
          >
            Términos y condiciones
          </Link>

          <Link
            style={linkStyle(isActive("/delete-account"))}
            to="/delete-account"
            onClick={closeMenu}
          >
            Eliminar cuenta
          </Link>

          <Link
            style={linkStyle(isActive("/support"))}
            to="/support"
            onClick={closeMenu}
          >
            Soporte
          </Link>
        </nav>

        <button
          type="button"
          style={logoutButtonStyle}
          onClick={() => {
            closeMenu();
            handleLogout();
          }}
        >
          Cerrar sesión
        </button>
      </aside>

      {/* Contenido */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}